/**
 * --------------------------------------------------------------------
 * jQuery-Plugin Content Slider
 * Version: 1.0, 03.07.2014
 * Version: 1.1, 15.01.2018
 *
 * by Lance Oliver Cummings, lance@glance.ca
 *
 *
 * 
 *
 * --------------------------------------------------------------------
 * Changelog:
 * 
 * --------------------------------------------------------------------
 */

(function($) {

    $.fn.slider = function(settings) {
        
        settings = $.extend({
            slides: '.slide',                       // slides
            transitionStyle: 'slide',               // transition style: 'fade' or 'slide'
            transitionSpeed: 450,                   // animation transition speed
            transitionDelay: 0,                     // delay between notifying slide of a transition, and making the transition
            autoSlide: 0                            // miliseconds between auto transitions (0 = no auto slide)
        }, settings);
                
        var $slider = $(this);
        var $slides = $slider.find(settings.slides);
                
        if ($slides.length < 1) {
            $slider.css('display', 'none');
            return;
        }
        
        var $currentSlide;
        var currentId = null;
        var $selectedSlide;
        var selectedId = null;
        var transitionDelay = 0; // first time is 0, followed by value set in settings
        var direction = 1;
        var autoSlide = settings.autoSlide;

        
        if(autoSlide > 0) {
            initSlide(0);
            startAutoSlide();
        }
        
        
        function initSlide(id)
        {
            $currentSlide = currentId = 0;
            $selectedSlide = $slides.eq(id);
            selectedId = id;

            // Position slides for transition
            $slides.each(function() {
                var $self = $(this);
                if ($self.hasClass('selected')) {
                    $self.css('z-index',2);
                    $currentSlide = $self;
                    currentId = $self.index();
                } else {
                    $self.css({'z-index':1});
                    if (settings.transitionStyle == 'slide' || settings.transitionStyle == 'fade') {
                        $self.css({'opacity':0});
                    }
                }
            });
            
            direction = currentId > selectedId ? -1 : 1;
            var $direction_class = direction < 1 ? 'back' : 'forward';
            
            $slides.removeClass('current selected back forward').addClass($direction_class);
            $selectedSlide.addClass('selected').css('z-index',3);
            
            if (!$currentSlide.length) {
                $currentSlide = $selectedSlide;
            }
            
            if (currentId == 0 && selectedId == $slides.length-1) direction = $slides.length > 2 ? -1 : 1;
            if (currentId == $slides.length-1 && selectedId == 0) direction = $slides.length > 2 ? 1 : -1;
            
            $slider.trigger('transition_out', [$currentSlide, $selectedSlide, direction]); // broadcast slide is transitioning out
            
            if (transitionDelay > 0) {
                $slider.stopTime('sliderDelay', showSlide).oneTime(transitionDelay, 'sliderDelay', showSlide);
            } else {
                showSlide();
            }
        }
        
        function showSlide()
        {

            // reset delay
            if (transitionDelay == 0) transitionDelay = settings.transitionDelay;

            // show selected
            $selectedSlide.addClass('current');

            // Transition: slide
            if (settings.transitionStyle == 'slide') {
                
                if (direction < 1) {
                    if ($currentSlide != $selectedSlide) {
                        $currentSlide.stop().css({'left':'0'}).velocity({'left':'100%'}, {duration: settings.transitionSpeed, easing: 'easeOutSine'});
                    }

                    $selectedSlide.stop().css({'left':'-100%', 'opacity':1}).velocity({'left':'0'}, {duration: settings.transitionSpeed, easing: 'easeOutSine', complete: function() {
                        $slider.trigger('transition_in', [$selectedSlide, direction]); // broadcast slide is transitioned in
                    }});
                    
                } else {
                    if ($currentSlide != $selectedSlide) {
                        $currentSlide.stop().css({'left':'0'}).velocity({'left':'-100%'}, {duration: settings.transitionSpeed, easing: 'easeOutSine'});
                    }

                    $selectedSlide.stop().css({'left':'100%', 'opacity':1}).velocity({'left':'0'}, {duration: settings.transitionSpeed, easing: 'easeOutSine', complete: function() {
                        $slider.trigger('transition_in', [$selectedSlide, direction]); // broadcast slide is transitioned in
                    }});
                }
            
            // Transition: fade
            } else if (settings.transitionStyle == 'fade') {
                $selectedSlide.stop().velocity("fadeIn", {duration: settings.transitionSpeed, easing: 'easeOutSine', complete: function() {
                    $slider.trigger('transition_in', [$selectedSlide, direction]); // broadcast slide is transitioned in
                }});

            // Transition: custom (no built-in effects)
            } else {
                $slider.trigger('transition_in', [$selectedSlide, direction]); // broadcast slide is transitioned in
            }
            
        }
        
        
        function slideAt(id)
        {
            initSlide(id);
        }
        
        function prevSlide()
        {
            var prevId = selectedId != null ? selectedId-1 : -1;
            
            if (prevId < 0) {
                prevId = $slides.length - 1;
            }
                        
            initSlide(prevId);
        }
        
        function nextSlide()
        {
            var nxtId = selectedId != null ? selectedId+1 : 0;
            
            if (nxtId >= $slides.length) {
                nxtId = 0;
            }

            initSlide(nxtId);
        }
        
        function stopAutoSlide()
        {
            autoSlide = 0;
            $slider.stopTime('autoSlideTimer', nextSlide);
        }
        
        function startAutoSlide(interval)
        {
            autoSlide = typeof interval != 'undefined' ? interval : settings.autoSlide;
            if (autoSlide > 0 && $slides.length > 1) $slider.everyTime(autoSlide, 'autoSlideTimer', nextSlide);
        }
        
        function resetAutoSlide()
        {
            if (autoSlide > 0 && $slides.length > 1) $slider.stopTime('autoSlideTimer', nextSlide).everyTime(autoSlide, 'autoSlideTimer', nextSlide);
        }
        
        var slider = {
            at:   function(id) { resetAutoSlide(); slideAt(id); },
            back: function() { resetAutoSlide(); prevSlide(); },
            next: function() { resetAutoSlide(); nextSlide(); },
            start: function(interval) { startAutoSlide(interval); },
            stop: function() { stopAutoSlide(); }
        };
        
        return slider;
    }
    
})(jQuery);

